import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';

function NavCategoriesUI() {
    this.defaultAttrs({
        categoryLink: '[data-nav-categories-sub]'
    });

    this._toggleMenu = function(evt, params) {
        let toggleClass = 'open';
        if (params.open === true) {
            this.$node.addClass(toggleClass);
        } else {
            this.$node.removeClass(toggleClass);
        }
    };

    this._toggleSubCategory = function(evt, orgEvt) {
        evt.preventDefault();

        let target = $(orgEvt.el),
            openClass = 'open';

        if (target.hasClass(openClass)) {
            target.removeClass(openClass);
        } else {
            target.addClass(openClass);
        }
    };

    this.after('initialize', function() {
        this.on(
            document,
            'ui:site-header:on-toggle-nav-categories',
            this._toggleMenu
        );

        this.on('click', {
            categoryLink: this._toggleSubCategory
        });
    });
}

export default defineComponent.component(NavCategoriesUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/nav-categories-ui.js